import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink, withRouter } from 'react-router-dom';

const SidebarLink = ({
  title = '',
  icon = '',
  newLink = false,
  route = '/',
  onClick = () => { },
  history,
  ...props
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    // Close the sidebar immediately
    onClick();
    // Navigate after a tiny delay to allow the state update to begin
    setTimeout(() => {
      history.push(route);
    }, 50);
  };

  return (
    <NavLink
      to={route}
      onClick={handleClick}
      activeClassName="sidebar__link-active"
    >
      <li className="sidebar__link">
        {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : null}
        {/* Support for Material UI Icon Component */}
        {props.materialIcon && React.createElement(props.materialIcon, { className: 'sidebar__link-icon', style: { fontSize: 18, marginRight: 10 } })}

        <p className="sidebar__link-title">
          {title}
          {newLink ? <Badge className="sidebar__link-badge"><span>New</span></Badge> : null}
        </p>
      </li>
    </NavLink>
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default withRouter(SidebarLink);
